<div class="sidebar-detail">
  <div class="sidebar-panel">
    <div class="sidebar-content">
      <div class="detail-section">
        @let precision = detail?.currencyDisplayPrecision ?? 8;
        @if (displayDescription) {
          <div class="detail-row">
            <div class="field-label">Description</div>
            <div class="field-value description-value">{{ displayDescription }}</div>
          </div>
        }
        @if (detail?.isTransfer) {
          <div class="detail-row">
            <div class="field-label">Action</div>
            <div class="field-value description-value">
              Capture this deposit manually, then acknowledge. Once acknowledged, this task is not raised again.
            </div>
          </div>
        }
        <div class="detail-row">
          <div class="field-label">Merchant</div>
          <div class="field-value">{{ detail?.merchantName || 'N/A' }}</div>
        </div>
        <div class="detail-row">
          <div class="field-label">Network</div>
          <div class="field-value">{{ detail?.networkName || 'N/A' }}</div>
        </div>
        <div class="detail-row">
          <div class="field-label">Currency</div>
          <div class="field-value">{{ detail?.currencySymbol || 'N/A' }}</div>
        </div>
        <div class="detail-row">
          <div class="field-label">Amount</div>
          <div class="field-value">{{ detail?.needsManualReview ? 'To be reviewed' : (detail?.unrecordedAmount | formatCoinCurrency: precision) }}</div>
        </div>
        @if (!detail?.isTransfer) {
          <div class="detail-row">
            <div class="field-label">On-chain Balance</div>
            <div class="field-value">{{ detail?.onChainBalance | formatCoinCurrency: precision }}</div>
          </div>
          <div class="detail-row">
            <div class="field-label">Recorded {{ detail?.currencySymbol || 'Balance' }}</div>
            <div class="field-value">{{ detail?.recordedBySystem | formatCoinCurrency: precision }}</div>
          </div>
        }
        @if (detail?.isTransfer) {
          <div class="detail-row">
            <div class="field-label">Transaction Date</div>
            <div class="field-value">{{ formatDateStandard(detail.transactionTime) || 'N/A' }}</div>
          </div>
        }
        <div class="detail-row">
          <div class="field-label">Detected Date</div>
          <div class="field-value">{{ formatDateStandard(detail?.detectedAt) || 'N/A' }}</div>
        </div>
        @if (isHistory) {
          <div class="detail-row">
            <div class="field-label">Resolved at</div>
            <div class="field-value">{{ formatDateStandard(resolvedAt) || '-' }}</div>
          </div>
        } @else {
          <div class="detail-row">
            <div class="field-label">Created Date</div>
            <div class="field-value">{{ formatDateStandard(createdDate) || 'N/A' }}</div>
          </div>
        }
        <div class="detail-row">
          <div class="field-label">Prepared by</div>
          <div class="field-value">{{ preparedBy || 'N/A' }}</div>
        </div>
        @if (isHistory) {
          <div class="detail-row">
            <div class="field-label">Resolved by</div>
            <div class="field-value">{{ resolvedBy || 'N/A' }}</div>
          </div>
        }
        <div class="detail-row">
          <div class="field-label">Status</div>
          <div class="field-value">
            <app-state-badge [status]="status"></app-state-badge>
          </div>
        </div>
        <div class="detail-row">
          <div class="field-label">Wallet ID</div>
          <div class="field-value description-value">{{ detail?.twinWalletId || 'N/A' }}</div>
        </div>
        <div class="detail-row">
          <div class="field-label">Wallet Name</div>
          <div class="field-value">{{ detail?.walletName || 'N/A' }}</div>
        </div>
        <ng-container
          *ngTemplateOutlet="copyableRow; context: { label: 'Wallet Address', value: detail?.walletAddress, field: 'wallet' }"
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="
            copyableRow;
            context: { label: 'Transaction Hash', value: detail?.transactionHash, field: 'hash', url: explorerUrl }
          "
        ></ng-container>
        @if (relatedTransactionId) {
          <ng-container
            *ngTemplateOutlet="
              copyableRow;
              context: { label: 'Transaction ID', value: relatedTransactionId, field: 'transaction', opensWallet: canOpenTransaction }
            "
          ></ng-container>
        }
        @if (isHistory) {
          <div class="comments-heading">Comments</div>
          <textarea class="comment-box" aria-label="Comments" readonly placeholder="No comment">{{ comment }}</textarea>
        }
        @if (errorMessage) {
          <div class="error-message" role="alert">
            <mat-icon class="error-icon">error</mat-icon>
            {{ errorMessage }}
          </div>
        }
      </div>
    </div>
    @if (!isHistory) {
      <div class="sidebar-actions">
        <div class="comments-heading">Comments</div>
        <textarea
          class="comment-box"
          aria-label="Comments"
          [(ngModel)]="commentText"
          placeholder="Enter your comment"
          [disabled]="isProcessing"
        ></textarea>
        <div class="button-group">
          <app-button buttonVariant="primary" buttonType="button" [state]="processingButtonState" (buttonClick)="onAcknowledge()">
            {{ isProcessing ? 'Processing...' : 'Acknowledge' }}
          </app-button>
        </div>
      </div>
    }
  </div>
  <ng-template #copyableRow let-label="label" let-value="value" let-field="field" let-url="url" let-opensWallet="opensWallet">
    <div class="detail-row">
      <div class="field-label">{{ label }}</div>
      @if (value) {
        <div class="field-value copyable-value olv-address">
          @if (url) {
            <a [href]="url" target="_blank" rel="noopener noreferrer" class="link" matTooltip="Go to blockchain" matTooltipPosition="above">{{
              shortenAddress(value)
            }}</a>
          } @else if (opensWallet) {
            <button
              type="button"
              class="link transaction-link"
              [matTooltip]="value"
              matTooltipPosition="above"
              [attr.aria-label]="shortenAddress(value) + ', go to wallet'"
              (click)="openTransaction()"
            >
              {{ shortenAddress(value) }}
            </button>
          } @else {
            <span tabindex="0" [matTooltip]="value" matTooltipPosition="above" [attr.aria-label]="value">{{
              shortenAddress(value)
            }}</span>
          }
          <button
            type="button"
            class="copy-icon-button"
            [matTooltip]="copiedField === field ? 'Copied' : 'Copy'"
            matTooltipPosition="above"
            #copyTooltip="matTooltip"
            [attr.aria-label]="'Copy ' + label.toLowerCase()"
            (click)="copy(value, field, copyTooltip)"
          >
            <img src="shared-assets/icons/copy.svg" class="copy-icon" alt="" />
          </button>
        </div>
      } @else {
        <div class="field-value">N/A</div>
      }
    </div>
  </ng-template>
</div>
